import { useEffect, useState } from "react";

// Turns a freshly picked File into a URL that can be shown immediately, without waiting for a
// round trip to storage. Calling URL.createObjectURL straight from render also works, but it
// mints a new URL on every render and never releases them; this revokes the previous one as
// soon as it is replaced, and again on unmount.
const useObjectUrl = (file) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setUrl(null);
      return undefined;
    }

    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return url;
};

export default useObjectUrl;
